import request from "@/providers/requests";
import ENDPOINTS from "@/providers/end-points";
import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";
import { SessionModel } from "@/modules/user";

const OocUserStore = {
  namespaced: true,
  state: () => ({
    session: null,
    message: null,
    error: null,
    success: false,
    isLoggedIn: false,
  }),
  getters: {
    oocIsLoggedIn: (state: any): boolean => state.isLoggedIn,
    oocSession: (state: any): any => state.session,
    oocError: (state: any) => state.error,
    oocSuccess: (state: any) => state.success,
    oocMessage: (state: any) => state.message,
  },
  mutations: {
    setUserLoggedIn(state: any, isLoggedIn: Boolean) {
      state.isLoggedIn = isLoggedIn;
    },

    setUserData(state: any, session: any) {
      state.session = session;
    },

    setError(state: any, error: []) {
      state.error = error;
    },

    setSuccess(state: any, success: boolean = false, message: string = "") {
      state.success = success;
      state.message = message;
    },
  },
  actions: {
    /**
     * Handle SSO each time user back to site
     * @param store
     * @return {void}
     */
    async oocSingleSignOn({ commit }: { commit: any }) {
      const user = Storage.get(StorageConstants.SESSION);
      if (!!user) {
        await commit("setUserData", user);
        await commit("setUserLoggedIn", true);
      }
    },

    /**
     * Handle login request
     * @param store
     * @param user
     * @return {<Promise>}
     */
    async oocDoLogin(store: any, user: any) {
      return await request
        .post(`${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.LOGIN}`, user)
        .then((response) => response.data)
        .then(async ({ data }: { data: any }) => {
          // save user data
          await Storage.set(StorageConstants.OOC_TOKEN, data.access_token);
          // await Storage.set(StorageConstants.OOC_SESSION, data);
          // await Storage.set(StorageConstants.OOC_PERMISSION, []);

          // trigger store user is logged in
          // await store.commit("setUserData", data);
          // await store.commit("setUserLoggedIn", true);
          await store.dispatch("OOCUsers/setProfile", null, { root: true });
        })
        .catch(async (error) => {
          await store.commit("setUserData", null);
          await store.commit("setUserLoggedIn", false);
          await store.commit("setSuccess", false, error?.detail);
          await store.commit("setError", error);
        });
    },

    /**
     * Handle login request
     * @param store
     * @return {<Promise>}
     */
    async setProfile(store: any) {
      return await request
        .get(`${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.ME}`)
        .then((response) => response.data)
        .then(async ({ data }: { data: any }) => {
          const user = new SessionModel(data);
          await Storage.set(StorageConstants.OOC_SESSION, data);
          await Storage.set(StorageConstants.OOC_PERMISSION, data.permissions);
          await store.commit("setUserData", user);
          await store.commit("setUserLoggedIn", true);
        })
        .catch(async (error) => {
          await store.commit("setUserData", null);
          await store.commit("setUserLoggedIn", false);
          await store.commit("setSuccess", false, error?.detail);
          await store.commit("setError", error);
        });
    },

    /**
     * Handle user logout
     * @param Store
     * @return {void}
     */
    async oocDoLogOut({ commit }: { commit: any }) {
      Storage.remove(StorageConstants.OOC_SESSION);
      Storage.remove(StorageConstants.OOC_TOKEN);
      await commit("setUserData", null);
      await commit("setUserLoggedIn", false);
    },
  },
};

export default OocUserStore;
